import { PercentageStatus } from "~/components/UI/PercentageComponent/types";

export const getPercentageStatus = (
  value: number | null | undefined
): PercentageStatus => {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return PercentageStatus.NEUTRAL;
  }
  if (value === 0) return PercentageStatus.NEUTRAL;
  return value > 0 ? PercentageStatus.GROW : PercentageStatus.DECLINE;
};
